import { toast } from "sonner";
import { Link } from "react-router-dom";
import { CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, useApi, fmtDate, EmptyState } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/i18n";

const KIND = { info: "bg-blue-500", success: "bg-emerald-500", warning: "bg-amber-500", error: "bg-red-500" };

export default function NotificationsView() {
  const { t } = useT();
  const notif = useApi("/tenant/notifications");
  const markAll = async () => { try { await api.post("/tenant/notifications/read-all"); notif.reload(); } catch (e) { toast.error(errMsg(e)); } };
  const mark = async (n) => { if (n.read) return; try { await api.post(`/tenant/notifications/${n.id}/read`); notif.reload(); } catch (e) { toast.error(errMsg(e)); } };
  const items = notif.data?.items || [];
  return (
    <div>
      <PageHeader title={t("notif.title")} subtitle={`${notif.data?.unread ?? 0} unread · in-app notifications are polled every 20 seconds (shared-hosting friendly).`} testId="notifications-page"
        actions={<Button variant="outline" data-testid="mark-all-read-btn" onClick={markAll}><CheckCheck className="h-4 w-4 mr-1" />{t("notif.mark_all")}</Button>} />
      {items.length === 0 && notif.data && <EmptyState title={t("notif.empty")} />}
      <ul className="space-y-2" data-testid="notifications-list">
        {items.map((n) => (
          <li key={n.id} data-testid={`notification-${n.id}`} onClick={() => mark(n)} className={`bg-card border rounded-lg p-4 flex gap-3 cursor-pointer hover:bg-secondary/40 transition-colors ${n.read ? "opacity-60" : ""}`}>
            <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${KIND[n.kind] || KIND.info}`} />
            <div className="flex-1 min-w-0"><div className="flex items-center justify-between gap-2"><span className="font-medium text-sm">{n.title}</span><span className="text-[11px] font-mono text-muted-foreground whitespace-nowrap">{fmtDate(n.created_at)}</span></div><p className="text-sm text-muted-foreground mt-0.5">{n.message}</p>{n.link && <Link to={n.link} className="text-xs text-blue-600">Open →</Link>}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
